"use client";

import * as React from "react";
import { useTranslations } from "next-intl";
import { Info } from "lucide-react";
import { useAuthStore } from "@/stores/auth-store";

/**
 * Banner permanente para cuentas demo. Se muestra bajo la navbar y explica
 * las limitaciones: es una cuenta de invitado, los datos son de ejemplo, se
 * puede crear 1 espacio, la Forja tiene cuota diaria.
 *
 * No se puede cerrar (a diferencia de un toast). Es informacion regulatoria.
 */
export function DemoBanner() {
  const t = useTranslations("demo_banner");
  const user = useAuthStore((s) => s.user);

  if (!user?.isDemo) return null;

  return (
    <div
      role="note"
      className="flex items-start gap-3 border-b border-amber-200 bg-amber-50 px-6 py-2 text-sm text-amber-900"
    >
      <Info className="h-4 w-4 shrink-0 mt-0.5" />
      <div className="flex-1 min-w-0">
        <span className="font-medium">{t("title")}</span>
        <span className="mx-2 text-amber-700">·</span>
        <span className="text-amber-800">{t("body")}</span>
        <span className="mx-2 text-amber-700">·</span>
        <span className="text-amber-800">{t("contact_prefix")}</span>{" "}
        <a
          href={`mailto:${t("contact_email")}`}
          className="font-medium underline decoration-amber-500 hover:text-amber-950"
        >
          {t("contact_email")}
        </a>
      </div>
    </div>
  );
}
